module.exports = __webpack_public_path__ + "img/t1.88160b12.jpg";